module.exports = __webpack_public_path__ + "static/media/landscape.41c5b93d.png";